import { put, takeLatest } from "redux-saga/effects";
import { postWatchedNotificationApi } from "store/api/NotificationApi";
import { POST_WATCHED_NOTIFICATION_ACTION } from "../../actions/NotificationPageAction/actionTypes";

import * as globalAction from "../../actions/GlobalAction";

function* errorMessage(message) {
	const alert = { isError: true, message: message, isOpenAlert: true };
	yield put(globalAction.setAlertMessage(alert));
}

function* postWatchedNotification(action) {
	yield put(globalAction.openLoadingPage());
	const data = {
		notificationId: action.params
	};
	const res = yield postWatchedNotificationApi(data);
	try {
		if (res?.code !== 0) {
			yield errorMessage(res?.message);
		}
	} catch (e) {
		console.log(e);
	} finally {
		yield put(globalAction.closeLoadingPage());
	}
}

function* postWatchedNotificationSaga() {
	yield takeLatest(POST_WATCHED_NOTIFICATION_ACTION, postWatchedNotification);
}

export default postWatchedNotificationSaga;
